export default __webpack_public_path__ + "static/media/Brow_2_C1.82cf02ad.svg";